/* lg-store-proximity.js — Stofind proximity ordering.
 * ================ ITEM 3 BLOCK — SEPARATELY REVIEWABLE ================
 * This file, snippets/lg-store-proximity-data.liquid, and the single render
 * line in sections/main-product.liquid are the whole feature. Remove all three
 * and Stofind v1.1 items 1 and 2 are untouched: badge line and <details> list
 * keep working in flagship order with no JavaScript.
 * ======================================================================
 *
 * PROGRESSIVE ENHANCEMENT, STRICTLY. Flagship order (the metafield's own order)
 * is what the server renders and what every visitor sees. This script only ever
 * REORDERS what is already there, after an explicit user gesture. No consent, no
 * geolocation API, blocked permission, a timeout, or any thrown error -> the
 * flagship order simply stands and the page is exactly as the server sent it.
 *
 * NO AUTOMATIC PROMPT. The permission dialog is fired from a click on a button
 * this script injects, never on load. An unprompted geolocation dialog on a
 * product page is hostile, and several browsers now ignore or auto-deny one that
 * is not tied to a gesture.
 *
 * TWO MEASURED CONSTRAINTS FROM THIS THEME:
 *  1. #LgBuyboxExtras-<section> has its innerHTML REPLACED on every variant
 *     change (assets/product-info.js:206, updateSourceFromDestination), and
 *     sections/main-product.liquid:523 records that scripts inside replaced
 *     innerHTML do not re-run. The <details> store list lives in there. So this
 *     script keeps NO references across time and re-applies from a
 *     MutationObserver instead of binding once at load.
 *  2. The badge line lives in .price, which is re-rendered on variant change
 *     too. Same handling.
 * Everything is therefore idempotent and re-entrant: applying twice is a no-op,
 * and a fresh copy of the markup is picked up automatically.
 */
(function () {
  'use strict';

  var DATA_ID = 'lg-store-proximity-data';
  var STORAGE_KEY = 'lgStoreProximity';
  var stores = null;         // [{handle,name,lat,lng}]
  var coords = null;         // {lat,lng} once consented
  var applying = false;

  function parseData() {
    if (stores) return stores;
    var el = document.getElementById(DATA_ID);
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      stores = Array.isArray(parsed) ? parsed : [];
    } catch (e) { stores = []; }
    return stores;
  }

  // Great-circle distance, km. Plain haversine - no library, no network.
  function distanceKm(aLat, aLng, bLat, bLng) {
    var R = 6371;
    var dLat = (bLat - aLat) * Math.PI / 180;
    var dLng = (bLng - aLng) * Math.PI / 180;
    var la1 = aLat * Math.PI / 180;
    var la2 = bLat * Math.PI / 180;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(la1) * Math.cos(la2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function byDistance(handles) {
    var known = parseData() || [];
    var index = {};
    for (var i = 0; i < known.length; i++) index[known[i].handle] = known[i];
    // A handle with no coordinates keeps its flagship position rather than being
    // given a guessed distance: stable sort, unknowns pushed to the end in their
    // original relative order.
    var withCoords = [], without = [];
    handles.forEach(function (h, idx) {
      var rec = index[h];
      if (rec && typeof rec.lat === 'number' && typeof rec.lng === 'number') {
        withCoords.push({ handle: h, idx: idx, km: distanceKm(coords.lat, coords.lng, rec.lat, rec.lng) });
      } else {
        without.push({ handle: h, idx: idx });
      }
    });
    withCoords.sort(function (a, b) { return a.km - b.km || a.idx - b.idx; });
    return withCoords.concat(without).map(function (x) { return x.handle; });
  }

  function nameFor(handle) {
    var known = parseData() || [];
    for (var i = 0; i < known.length; i++) if (known[i].handle === handle) return known[i].name;
    return handle;
  }

  // ── the expanded <details> list ────────────────────────────────────────────
  function reorderList(root) {
    var list = root.querySelector('.lg-store-expand__list');
    if (!list) return null;
    var items = Array.prototype.slice.call(list.children);
    var handles = items.map(function (li) {
      var a = li.querySelector('a');
      var m = a && a.getAttribute('href') ? a.getAttribute('href').match(/\/pages\/([^/?#]+)/) : null;
      return m ? m[1] : null;
    });
    if (handles.some(function (h) { return !h; })) return null;
    var ordered = byDistance(handles);
    var pos = {};
    handles.forEach(function (h, i) { pos[h] = items[i]; });
    ordered.forEach(function (h) { list.appendChild(pos[h]); });
    return ordered;
  }

  // ── the badge line, rebuilt with the same truncation rule as the Liquid ────
  // 1 -> name it; 2-3 -> name all; 4+ -> two + (total - 2) more stores.
  function rebuildBadge(ordered) {
    var line = document.querySelector('.lg-store-availability');
    if (!line || !ordered || !ordered.length) return;
    var total = parseInt(line.getAttribute('data-lg-store-count') || ordered.length, 10);
    var text;
    if (total <= 3) {
      text = 'Available for viewing at ' + ordered.slice(0, total).map(nameFor).join(', ');
    } else {
      var more = total - 2;
      text = 'Available for viewing at ' + ordered.slice(0, 2).map(nameFor).join(', ') +
             ' + ' + more + (more === 1 ? ' more store' : ' more stores');
    }
    line.textContent = text;
  }

  function applyOrder() {
    if (!coords || applying) return;
    applying = true;
    try {
      var root = document.querySelector('.lg-store-expand');
      var ordered = root ? reorderList(root) : null;
      if (ordered) {
        rebuildBadge(ordered);
        root.setAttribute('data-lg-proximity', 'on');
        var note = root.querySelector('.lg-store-expand__note');
        if (note) note.textContent = 'Sorted by distance from you';
        var btn = root.querySelector('.lg-store-expand__nearest');
        if (btn) btn.setAttribute('hidden', 'hidden');
      }
    } finally { applying = false; }
  }

  function setStatus(root, msg) {
    var note = root.querySelector('.lg-store-expand__note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'lg-store-expand__note';
      root.appendChild(note);
    }
    note.textContent = msg;
  }

  function requestLocation(root) {
    if (!navigator.geolocation) { setStatus(root, 'Location is not available in this browser.'); return; }
    setStatus(root, 'Finding your nearest showrooms...');
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(coords)); } catch (e) { /* private mode */ }
        applyOrder();
      },
      function () {
        // Denied, unavailable or timed out - flagship order stands, and the page
        // is left exactly as the server rendered it.
        setStatus(root, 'Showing our full list of showrooms.');
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
    );
  }

  // Inject the consent button. Idempotent: the markup may be replaced under us
  // at any time by a variant change, so this runs again on every mutation.
  function ensureButton() {
    var root = document.querySelector('.lg-store-expand');
    if (!root) return;
    if (coords) { applyOrder(); return; }
    if (root.querySelector('.lg-store-expand__nearest')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lg-store-expand__nearest';
    btn.textContent = 'Sort by nearest';
    btn.addEventListener('click', function () { requestLocation(root); });
    var list = root.querySelector('.lg-store-expand__list');
    if (list && list.parentNode) list.parentNode.insertBefore(btn, list);
    else root.appendChild(btn);
  }

  function restoreConsent() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && typeof c.lat === 'number' && typeof c.lng === 'number') coords = c;
      }
    } catch (e) { /* ignore */ }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      ensureButton();
    }, 0);
  }

  function init() {
    if (!parseData()) return;          // no payload -> nothing to do
    restoreConsent();
    ensureButton();
    // Re-apply after Dawn replaces the buybox or price markup on variant change.
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
